import CXMApiClient from '../CXMApiClient';
import {csv} from '../../lib/utilities/HelperFunctions';

function initialState() {
  return {};
}

const state = initialState();

const getters = {};

const actions = {
  getNewUserActivityData: function (context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      let filter;
      filter = request.Filter;
      filter.pagination = request.Pagination;
      await client.ProcessRequest('post', '/api/Team/team/filtered/paged', filter).then(response => {
        return resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getActivityReport: function (context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      let filter;
      filter = request.Filter;
      filter.pagination = request.Pagination;
      await client.ProcessRequest('post', '/api/Team/team/activity/csv', filter).then(response => {
        return resolve(csv.processCSV(response));
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getSoldData(context, request) {
    // Leaving here for placeholder
  },
  getCustomerEngagementReportData(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client.ProcessRequest('post', '/api/Report/report/customerEngagement', request.payload).then(response => {
        return resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getCustomerEngagementReportDetailData(context, request) {
   
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client.ProcessRequest('post', '/api/Report/report/customerengagementdetail/paging', request.payload).then(response => {
        return resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getEngagementReportCSV(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client.ProcessRequest('post', '/api/Report/report/customerEngagementcsv', request.payload).then(response => {
        return resolve(csv.processCSV(response));
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};




// WEBPACK FOOTER //
// ./src/store/modules/Reporting.js